export default __webpack_public_path__ + "static/media/rss-icon.c7df99e0.svg";